import React from 'react';

export const ConditionsTicker = ({
  backgroundColor = "#f7f5f3",
  textColor = "#272726",
  leadIn = "Shared by patients across more than 2,500 health conditions — including:",
  row1Conditions = "Heart disease • Type 2 diabetes • Breast cancer • Lung cancer • Cystic fibrosis • Alzheimer's disease • Parkinson's disease • Multiple sclerosis • Rheumatoid arthritis • ALS • Lupus • Crohn's disease • Sickle cell disease • Huntington's disease • PKU",
  row2Conditions = "Fibromyalgia • Chronic fatigue syndrome • Asthma • COPD • Myasthenia gravis • Hemophilia • Depression • Anxiety • Epilepsy • Psoriasis • Type 1 diabetes • Pompe disease • Gaucher disease • Fabry disease • Marfan syndrome • Narcolepsy"
}) => {
  return (
    <section
      style={{
        backgroundColor: backgroundColor,
        padding: '40px 0',
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      {/* Organic blob shapes */}
      <div
        style={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '150px',
          height: '150px',
          borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
          background: 'rgba(129, 156, 209, 0.08)',
          filter: 'blur(20px)',
          pointerEvents: 'none'
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '20%',
          right: '8%',
          width: '120px',
          height: '120px',
          borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
          background: 'rgba(250, 177, 132, 0.1)',
          filter: 'blur(20px)',
          pointerEvents: 'none'
        }}
      />
      {/* CSS Animations */}
      <style>
        {`
          @keyframes scrollRight {
            0% {
              transform: translateX(-50%);
            }
            100% {
              transform: translateX(0%);
            }
          }
          @keyframes scrollLeft {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .ticker-row-right {
            animation: scrollRight 85s linear infinite;
          }
          .ticker-row-left {
            animation: scrollLeft 85s linear infinite;
          }
        `}
      </style>

      {/* Lead-in text */}
      <p
        style={{
          fontSize: '16px',
          color: '#4A4A4A',
          textAlign: 'center',
          maxWidth: '600px',
          margin: '0 auto 24px',
          padding: '0 24px',
          lineHeight: '1.5',
          fontStyle: 'italic'
        }}
      >
        {leadIn}
      </p>

      {/* Row 1 - Scrolling Right */}
      <div
        style={{
          marginBottom: '16px',
          overflow: 'hidden'
        }}
      >
        <div
          className="ticker-row-right"
          style={{
            display: 'flex',
            width: 'fit-content',
            whiteSpace: 'nowrap'
          }}
        >
          {[1, 2, 3, 4].map((_, i) => (
            <span
              key={i}
              style={{
                fontFamily: '"Source Serif Pro", Georgia, serif',
                fontSize: 'clamp(18px, 2.5vw, 28px)',
                fontWeight: '400',
                color: textColor,
                paddingRight: '24px'
              }}
            >
              {row1Conditions} • {' '}
            </span>
          ))}
        </div>
      </div>

      {/* Row 2 - Scrolling Left */}
      <div
        style={{
          overflow: 'hidden'
        }}
      >
        <div
          className="ticker-row-left"
          style={{
            display: 'flex',
            width: 'fit-content',
            whiteSpace: 'nowrap'
          }}
        >
          {[1, 2, 3, 4].map((_, i) => (
            <span
              key={i}
              style={{
                fontFamily: '"Source Serif Pro", Georgia, serif',
                fontSize: 'clamp(18px, 2.5vw, 28px)',
                fontWeight: '400',
                color: textColor,
                paddingRight: '24px'
              }}
            >
              {row2Conditions} • {' '}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
